import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE = "lira_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [discountCode, setDiscountCodeState] = useState(() => localStorage.getItem("lira_discount") || "");

  const setDiscountCode = (code) => {
    const c = (code || "").trim().toUpperCase();
    setDiscountCodeState(c);
    if (c) localStorage.setItem("lira_discount", c);
    else localStorage.removeItem("lira_discount");
  };

  useEffect(() => {
    localStorage.setItem(STORAGE, JSON.stringify(items));
  }, [items]);

  const lineKey = (id, color, size) => `${id}__${color || ""}__${size || ""}`;

  const addItem = (product, color, quantity = 1, size = null) => {
    const chosenSize = size || (product.sizes && product.sizes[0]) || null;
    setItems((prev) => {
      const key = lineKey(product.id, color, chosenSize);
      const existing = prev.find((i) => lineKey(i.product_id, i.color, i.size) === key);
      if (existing) {
        return prev.map((i) =>
          lineKey(i.product_id, i.color, i.size) === key ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          price: product.price,
          image: product.images[0],
          color: color || (product.colors[0] && product.colors[0].name) || null,
          size: chosenSize,
          quantity,
        },
      ];
    });
    setOpen(true);
  };

  const updateQty = (product_id, color, size, quantity) => {
    if (quantity < 1) return;
    setItems((prev) =>
      prev.map((i) =>
        lineKey(i.product_id, i.color, i.size) === lineKey(product_id, color, size) ? { ...i, quantity } : i
      )
    );
  };

  const removeItem = (product_id, color, size) => {
    setItems((prev) => prev.filter((i) => lineKey(i.product_id, i.color, i.size) !== lineKey(product_id, color, size)));
  };

  const clear = () => { setItems([]); setDiscountCode(""); };

  const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, subtotal, count, open, setOpen, discountCode, setDiscountCode }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
